const LOGO = 'Logo';
const EMAIL = 'Email';
const GIFT_MESSAGE = 'Gift message';
const DIGITAL_WRAPPER = 'Digital wrapper';
const COLLECTION_DESC = 'Collection description';
const INPUT_MESSAGE = 'input-message';
const CARD_MESSAGE = 'card-message';

const GIFT_MESSAGE_TYPE = {
  inputMessage: INPUT_MESSAGE,
  cardMessage: CARD_MESSAGE
};

export { COLLECTION_DESC, DIGITAL_WRAPPER, EMAIL, GIFT_MESSAGE, GIFT_MESSAGE_TYPE, LOGO };
